module.exports = __webpack_public_path__ + "static/media/circle-x.4165cd18.svg";